import {FadeTransition} from '@aboutyou/transitions';
import {COLORS, FONT_SIZES} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useActivatedCouponState} from '../Coupons/useActivatedCouponState';
import {useProductIdFromSlug} from '../ProductUrl';

export const UnlockCouponSuccessHint: React.FC = () => {
  const productId = useProductIdFromSlug();
  const {unlockedCouponHeadline} = useActivatedCouponState(productId);

  return (
    <FadeTransition duration={500}>
      <SuccessHint $hasHint={Boolean(unlockedCouponHeadline)}>
        {unlockedCouponHeadline}
      </SuccessHint>
    </FadeTransition>
  );
};

const SuccessHint = styled.div<{$hasHint?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLORS.White};
  background-color: ${COLORS.PrimaryCoupon};
  font-size: ${FONT_SIZES.px12};
  height: ${({$hasHint}) => ($hasHint ? '30px' : '0')};
  overflow: hidden;
`;
